/* @ngInject */
class API {
	constructor(Restangular) {
		this.Restangular = Restangular;
	}

	service(object) {
		let service = this.Restangular.service(object);

		// Some guidance taken from https://github.com/mgonto/restangular/pull/1134#issuecomment-133371800
		service.one = (id) => {
			return this.Restangular.one(object, id);
		};

		return service;
	}
}

export default API;


// WEBPACK FOOTER //
// ./src/js/services/api/index.js